module.exports = __webpack_public_path__ + "img/arrow-bold-reply.c3557eb6.svg";